import { ApiGetCall } from '../../../JS/Connector';
import { formatDateToMMDDYYYY, HideLoder, LogInSchoolID, ShowLoder } from '../../../JS/Common';
import { useState } from 'react';
import AlertsComp from '../../../Components/AlertsComp';

export default function Exportusers({ FilterData, setAlerts }) {
    const [loading, setLoading] = useState(false);

    async function ExportUsers() {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            setAlerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
        }, 2000);

        setTimeout(() => {
            setAlerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/utilizers/export-legacy?schoolId=${LogInSchoolID}&startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}`)
        }, 0)
    }
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}

            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Export Users</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    Would you like to export your user data? To do so, simply click on the 'Export Users' button.
                </p>
                <div className="row pt-3 pb-2 px-3">
                    <div className="col-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={ExportUsers}>Export Users
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>

                </div>
            </div>

        </>
    )
}
